import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export type UsualSuspect = {
  itemId:   string
  name:     string
  addCount: number
}

export function useUsualSuspects(householdId: string | null): {
  suspects: UsualSuspect[]
  loading:  boolean
} {
  const [suspects, setSuspects] = useState<UsualSuspect[]>([])
  const [loading,  setLoading]  = useState(true)

  useEffect(() => {
    if (!householdId) { setLoading(false); return }

    let cancelled = false
    setLoading(true)

    ;(async () => {
      const { data, error } = await supabase.rpc('get_usual_suspects', {
        p_household_id: householdId,
      })

      if (cancelled) return

      if (error || !data) { setSuspects([]); setLoading(false); return }

      setSuspects(
        (data as any[]).map(r => ({
          itemId:   r.item_id,
          name:     r.item_name,
          addCount: r.add_count,
        })),
      )
      setLoading(false)
    })()

    return () => { cancelled = true }
  }, [householdId])

  return { suspects, loading }
}
